import { getDateConfiguration } from "@/helpers/dates.helper.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { EmployeeDatesFormat } from "@/types/organization.types.ts";
import { DatepickerConfig } from "@skailer-com/uikit";
import { ru } from "date-fns/locale/ru";
import { enUS } from "date-fns/locale/en-US";
import { useTranslation } from "react-i18next";

export const useDatepickerConfig = (): DatepickerConfig => {
  const { data: employee } = useEmployeeMe();
  const { renderDate, renderShortDate, renderRelativeDate } = useFormatter();
  const { t } = useTranslation();

  const dateConfiguration = getDateConfiguration(
    employee?.organization.default_date_format ?? EmployeeDatesFormat.dd_mm_yyyy
  );

  return {
    dateConfiguration,
    locale: employee?.language === "ru" ? ru : enUS,
    placeholderText: t(dateConfiguration.placeholder),
    formatDate: (date: Date): string => renderDate(date),
    formatShortDate: (date: Date): string => renderShortDate(date) ?? "",
    formatRelativeDate: (date: Date, showTime: boolean): string =>
      renderRelativeDate(date, showTime),
  };
};
